var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 11.17 1.83 7 .41 8.41 6 14 18 2 16.59.59z"
  })));
};
export { SvgCheckmark as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxOCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuMDAwMTYgMTEuMTY5OEwxLjgzMDE2IDYuOTk5ODRMMC40MTAxNTYgOC40MDk4NEw2LjAwMDE2IDEzLjk5OThMMTguMDAwMiAxLjk5OTg0TDE2LjU5MDIgMC41ODk4NDRMNi4wMDAxNiAxMS4xNjk4WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";